// Icons for lists, pickers and strips. V3.9.1: the art lives in ./vehicleIcons (12 types, side-profile glyphs here,
// rotating top-down silhouettes on the map — see ./vehicleMarker). Old values (bus, truck, boat, bike) still work.
import { VEHICLE_ICONS, glyphSvg } from "./vehicleIcons";

export { normIcon, legacyIconMap, ICON_VALUES, isVessel } from "./vehicleIcons";

/** Picker entries, in display order (4 × 3 grid). */
export const ICONS: Record<string, { label: string; hint: string }> =
  Object.fromEntries(VEHICLE_ICONS.map((i) => [i.value, { label: i.label, hint: i.hint }]));

/** Preset colours offered for icons and tails (null = automatic). */
export const DISPLAY_COLOURS = ["#257AF4", "#16A34A", "#F59E0B", "#DC2626", "#7C3AED", "#DB2777", "#0891B2", "#111827"];

/** Side-profile glyph (drawn a little larger than the old icons — the side views are wide and detailed). */
export function iconSvg(name: string | null | undefined, size = 14) {
  return glyphSvg(name, Math.round(size * 1.2));
}
